import { ComponentProps } from 'react';

export function FileIcon(props: ComponentProps<'svg'>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33366 6.66383C3.19699 6.6603 3.09774 6.65239 3.00851 6.63464C2.34736 6.50313 1.83053 5.9863 1.69902 5.32515C1.66699 5.16415 1.66699 4.97055 1.66699 4.58333C1.66699 4.19612 1.66699 4.00251 1.69902 3.84152C1.83053 3.18037 2.34736 2.66354 3.00851 2.53202C3.16951 2.5 3.36311 2.5 3.75033 2.5H16.2503C16.6375 2.5 16.8311 2.5 16.9921 2.53202C17.6533 2.66354 18.1701 3.18037 18.3016 3.84152C18.3337 4.00251 18.3337 4.19612 18.3337 4.58333C18.3337 4.97055 18.3337 5.16415 18.3016 5.32515C18.1701 5.9863 17.6533 6.50313 16.9921 6.63464C16.9029 6.65239 16.8037 6.6603 16.667 6.66383M8.33366 10.8333H11.667M3.33366 6.66667H16.667V13.5C16.667 14.9001 16.667 15.6002 16.3945 16.135C16.1548 16.6054 15.7724 16.9878 15.302 17.2275C14.7672 17.5 14.0671 17.5 12.667 17.5H7.33366C5.93353 17.5 5.23346 17.5 4.69868 17.2275C4.22828 16.9878 3.84583 16.6054 3.60614 16.135C3.33366 15.6002 3.33366 14.9001 3.33366 13.5V6.66667Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
